import { Divider, Segmented } from 'antd';
import { useState } from 'react';
import TemplatesAdminSource from './TemplatesAdminSource.page';
import TemplatesAdminTarget from './TemplatesAdminTarget.page';

const TemplateAdminPage = () => {
  const [selectedTemplatesDataSource, setSelectedTemplatesDataSource] =
    useState([]);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleRefresh = () => {
    setRefreshTrigger((prev) => prev + 1);
  };

  return (
    <div className="flex flex-row pt-4 min-h-screen">
      <TemplatesAdminSource
        setSelectedTemplatesDataSource={setSelectedTemplatesDataSource}
        selectedTemplatesDataSource={selectedTemplatesDataSource}
        refreshTrigger={refreshTrigger}
      />
      <Divider
        type="vertical"
        style={{
          height: 'auto',
          margin: '0 16px',
          borderColor: '#00D090',
          borderWidth: '0.5px',
        }}
      />
      <TemplatesAdminTarget
        selectedTemplatesDataSource={selectedTemplatesDataSource}
        onSuccessfulPush={handleRefresh}
      />
    </div>
  );
};

export default TemplateAdminPage;
